module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/alizee.6f0808b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/alizee.jpg
// module id = Ljhg
// module chunks = 0